import React from 'react'
import MiniSwiper from '~/components/common/MiniSwiper';
import css from "./index.css"
import sharedCSS from '../shared.css';
import cs from 'classnames'
import { track } from '~/misc/metrics';
const swiperConfig = [
  {
    title: "Most Popular Driver App",
    content: "Leverage the #1 mapping and navigation app used by over 1M truck drivers while over-the-road for essential services.",
    pic: css.pic1,
    url: "https://command.truckerpath.com/overview?point=TL%20Carrier%20Web%20Most%20Popular&utm_source=TL%20Carrier%20Web%20Most%20Popular",
    click: ()=>{
      track("Command Ad", {
        source: "Most Popular"
      })
    }
  },
  {
    title: "Enterprise Truck Navigation",
    content: "Equip your drivers with our industry leading truck-safe navigation system.",
    pic: css.pic2,
    url: "https://command.truckerpath.com/overview?point=TL%20Carrier%20Web%20Navigation&utm_source=TL%20Carrier%20Web%20Navigation",
    click: ()=>{
      track("Command Ad",{
        source: "Navigation"
      })
    }
  },
  {
    title: "All-in-one Trucking Software",
    content: "Navigate, dispatch, workflows, and more between your driver app and web portal.",
    pic: css.pic3,
    url: "https://command.truckerpath.com/overview?point=TL%20Carrier%20Web%20All%20in%20one&utm_source=TL%20Carrier%20Web%20All%20in%20one",
    click: ()=>{
      track("Command Ad", {
        source: "All in one"
      })
    }
  },
  {
    title: "Load Management",
    content: "Comprehensive workflows for load dispatching, tracking, document scanning, settlements, and accounting.",
    pic: css.pic4,
    url: "https://command.truckerpath.com/overview?point=TL%20Carrier%20Web%20Load%20management&utm_source=TL%20Carrier%20Web%20Load%20management",
    click: ()=>{
      track("Command Ad", {
        source: "Load management"
      })
    }
  },
  {
    title: "Driver Management",
    content: "A centralized platform to communicate and manage driver activity, compliance, and productivity.",
    pic: css.pic5,
    url: "https://command.truckerpath.com/overview?point=TL%20Carrier%20Web%20Driver%20management&utm_source=TL%20Carrier%20Web%20Driver%20management",
    click: ()=>{
      track("Command Ad", {
        source: "Driver management"
      })
    }
  },
  {
    title: "Open Integrations",
    content: "Connect with your existing platforms, ELD, tracking platforms in single source of truth.",
    pic: css.pic6,
    url: "https://command.truckerpath.com/overview?point=TL%20Carrier%20Web%20Integrations&utm_source=TL%20Carrier%20Web%20Integrations",
    click: ()=>{
      track("Command Ad", {
        source: "Integrations"
      })
    }
  },
]

export const CommandSwiper = () => {
  return (
    <div>
      <div className={cs(sharedCSS.h1, css.header)}>Fleets and Dispatchers</div>
      <MiniSwiper
        items = {swiperConfig}
      ></MiniSwiper>
    </div>
  )
} 


// WEBPACK FOOTER //
// ./src/components/CommandSwiper/index.js